<template>
  <v-system-bar class="system-bar">
    <!-- Container to hold all items for better control -->
    <div class="d-flex flex-row align-center justify-space-between system-bar-content">
      <!-- Weather Condition -->
      <div class="system-bar-item" v-if="saaData">
        <v-icon small>mdi-weather-sunny</v-icon>
        {{ saaData.ilma.lampotila }}°C
        <template v-if="saaData.ilma.tuuli != null">
          {{ saaData.ilma.tuuli }}m/s
          <v-icon small :style="windIconStyle">mdi-arrow-up</v-icon>
        </template>
      </div>
      <!-- Water Level -->
      <div class="system-bar-item" v-if="saaData && saaData.vesi.korkeus != null">
        <v-icon small>mdi-water</v-icon>
        {{ waterLevel }}cm
      </div>
      <!-- Indoor Temperature -->
      <div class="system-bar-item" v-if="shelly && shelly.htData && shelly.htData.temperature">
        <v-icon small>mdi-home-thermometer</v-icon>
        {{ shelly.htData.temperature.toFixed(1) }}°C
      </div>
      <!-- Power Output -->
      <div class="system-bar-item" v-if="shelly && shelly.plugData" :class="{'red--text' : shelly.plugData.apower > 0}">
        <v-icon small :color="powerOutput > 0 ? 'red' : 'gray'" >mdi-flash</v-icon>
        {{ powerOutput }}kW
      </div>
    </div>
  </v-system-bar>
</template>

<script>
import api from "@/api";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Saa',
  data() {
    return {
      saaData: null,
    }
  },
  computed: {
    ...mapGetters('shelly', ['shellyData']),
    shelly() {
      return this.shellyData;
    },
    waterLevel() {
      const rounded = Math.round(this.saaData.vesi.korkeus);
      return rounded >= 0 ? `+${rounded}` : `${rounded}`;
    },
    windIconStyle() {
      const adjustedDirection = (this.saaData.ilma.tuuliSuunta + 180) % 360;
      return {
        transform: `rotate(${adjustedDirection}deg)`
      };
    },
    powerOutput() {
      if (!this.shelly && this.shelly.plugData && this.shelly.plugData.apower) return '0.0';
      const power = this.shelly.plugData.apower / 1000;
      return power.toFixed(1);
    }
  },
  methods: {
    ...mapActions('shelly', ['fetchShellyData']),
    async reloadSaa() {
      this.saaData = await api.saaData();
    }
  },
  mounted() {
    this.reloadSaa();
  }
}
</script>

<style scoped>
.system-bar {
  width: 100%;
  overflow-x: auto;
}

.system-bar-content {
  width: 100%;
  max-width: 800px; /* Adjust this value based on your design preference */
  margin: 0 auto;
}

.system-bar-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px; /* Adjust the spacing between items */
}

/* Reduce the margin for smaller screens */
@media (max-width: 600px) {
  .system-bar-item {
    margin-right: 4px; /* Less space between items on smaller screens */
  }
}
</style>
